<template>
    <div>
      <transition name="fade" @before-enter="beforeEnter" @enter="enter" @leave="leave">
        <div v-if="displayedItems.length" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          <div
            v-for="(channel, index) in displayedItems"
            :key="index"
            ref="channelCard"
            class="relative bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 hover:bg-gray-50"
          >
            <!-- Share button -->
            <button
              @click="openShareModal(index)"
              class="absolute top-2 right-2 border bg-gray-100 text-gray-500 px-3 py-1 rounded-sm hover:bg-blue-500 hover:text-white transition-opacity duration-300 card-hover-btn"
            >
              <i class="fas fa-share-alt"></i>
            </button>
  
            <!-- Logo, name, and scale -->
            <div class="flex items-center justify-start px-6 pt-5">
              <div>
                <a :href="channel.siteurl" target="_blank" class="text-xl font-semibold text-gray-800 hover:text-blue-500 transition-colors">
                  {{ channel.name }}
                </a>
                <p class="text-sm text-gray-500 mt-3">
                  <span>{{ $t('channel.scale') }}: </span>
                  <span class="upvote-number">{{ channel.scale }}</span>
                </p>
              </div>
            </div>
  
            <!-- Brief and detail description -->
            <div class="px-6 py-4">
              <div class="text-gray-800 font-medium mb-2 chinese-description">
                <p>{{ channel.一句话简介 }}</p>
              </div>
              <div class="text-gray-600 text-sm leading-relaxed purpose-description">
                <p v-for="(part, index) in highlightedPurpose(channel.详情介绍)" :key="index" v-html="part"></p>
              </div>
  
              <!-- DA, PA, and price tags -->
              <div class="flex flex-wrap gap-2 mt-3">
                <span 
                  v-if="channel.price" 
                  :class="['tag', channel.price === 'Free' ? 'price-free' : 'price-paid']"
                >
                  {{ channel.price }}
                </span>
                <span v-if="channel.DA" class="tag">{{ channel.DA }}</span>
                <span v-if="channel.PA" class="tag">{{ channel.PA }}</span>
              </div>
            </div>
          </div>
        </div>
      </transition>
  
      <!-- "显示更多"按钮 -->
      <button
        v-if="hasMoreItems"
        @click="loadMore"
        class="show-more-button mt-6 mx-auto block flex items-center space-x-2 px-6 py-1 text-gray-400 hover:text-blue-500 transition-colors duration-200">
        <i class="fas fa-angle-double-down"></i>
        <span>{{ $t('interface.show_more') }}</span>
      </button>
  
      <!-- 分享弹窗（独立组件，承载模板/样式/校验） -->
      <ShareModal :visible="showModal" :is-generating="isGenerating" @submit="onShareSubmit" @close="closeModal" />
    </div>
  </template>
  
  <script>
    import ShareModal from './ShareModal.vue'; // 分享弹窗（公共组件）
    import gridPaginationMixin from '../mixins/gridPaginationMixin'; // 分页状态机
    import transitionMixin from '../mixins/transitionMixin'; // 淡入过渡钩子
    import gridShareMixin from '../mixins/gridShareMixin'; // 分享逻辑（showModal/isGenerating/onShareSubmit 等）
import { splitPurposeByLine } from '../utils/purpose'; // 用途说明按换行拆分（Funding/Channel 共用）

    export default {
        components: {
          ShareModal,
        },
        mixins: [gridPaginationMixin, transitionMixin, gridShareMixin],
        props: {
            channels: {
            type: Array,
            required: true
            }
        },
        data() {
            return {
            itemsPerPage: 9, // 每次加载的条目数
            sourceKey: 'channels',
            paginationGtagLabel: 'channel',
            infiniteScroll: false, // ChannelGrid 仅按钮翻页，无滚动无限加载
            // 分享图配置（覆盖 gridShareMixin 默认）
            shareCardRef: 'channelCard',
            shareCardWidth: 400,
            shareGtagType: 'channel',
            };
        },
        methods: {
        highlightedPurpose(purpose) {
          return splitPurposeByLine(purpose);
        },
      },
    };
</script>
  
  <style scoped>
.chinese-description {
  font-size: 1rem;
  font-weight: 500;
  color: #333;
}

.purpose-description {
  font-size: 0.875rem;
  color: #666;
  line-height: 1.6;
}

/* 卡片 hover 显示分享按钮 */
.card-hover-btn {
  opacity: 0;
}

.relative:hover .card-hover-btn {
  opacity: 1;
  transition: opacity 0.3s ease;
  background-color: #f3f4f6;
  color: #4b5563;
}

.relative:hover .card-hover-btn:hover {
  background-color: #dbeafe;
  color: #1d4ed8;
}

/* upvote-number 样式 */
.upvote-number {
  @apply text-red-500 font-bold text-[14px];
}

/* 显示更多按钮特定样式 */
.show-more-button {
  padding: 0;
  border: none;
  background-color: transparent;
  color: #6b7280;
  border-radius: 0;
  font-size: 14px;
  cursor: pointer;
}

.show-more-button:hover {
  color: #2563eb;
  background-color: transparent;
}

.tag {
  @apply bg-blue-100 text-blue-700 px-2 py-1 rounded-full text-[11px] font-medium hover:bg-blue-200 transition-colors duration-300 border-0;
}
/* 绿色系样式：适用于“Free” */
.price-free {
  @apply bg-green-100 text-green-700 hover:bg-green-200;
}

/* 红色系样式：适用于收费 */
.price-paid {
  @apply bg-red-100 text-red-700 hover:bg-red-200;
}
  </style>
